// eslint-disable-next-line @typescript-eslint/naming-convention
export enum EIdIconType {
  BankId = 'BankId',
  BankIdNo = 'BankIdNo',
  NemId = 'NemId',
  NemIdOrg = 'NemIdOrg',
  MitIdDark = 'MitIdDark',
}
